"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RenderPreviewImage = exports.PreviewImage = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const app_1 = require("app");
const React = require("react");
const PreviewBox_1 = require("../PreviewBox/PreviewBox");
const MosaicIcon_1 = require("Views/Shared/Components/MosaicIcon");
const PreviewImage = ({ videoUrl, playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel, }) => {
    const videoImgUrl = React.useMemo(() => app_1.VideoService.getPreviewImage(videoUrl), [videoUrl]);
    const handleOnClick = React.useCallback(() => {
        if (app_1.VideoService.checkIsValidVideo(videoUrl)) {
            (0, PreviewBox_1.renderPreviewBox)(videoUrl, popupAriaLabel, closeButtonAriaLabel);
        }
    }, [closeButtonAriaLabel, popupAriaLabel, videoUrl]);
    const handleOnKeyPress = React.useCallback((event) => {
        if (event.key === app_1.keyNameMapping.enter || event.key === app_1.keyNameMapping.space) {
            handleOnClick();
        }
    }, [handleOnClick]);
    return ((0, jsx_runtime_1.jsxs)("div", { onClick: handleOnClick, onKeyDown: handleOnKeyPress, className: videoUrl ? 'video-preview-wrapper relative cursor-pointer' : '', children: [(0, jsx_runtime_1.jsx)("div", { className: "video-preview-image bg-no-repeat bg-cover bg-center aspect-video rounded-4xl", style: { backgroundImage: `url(${videoImgUrl})` } }), (0, jsx_runtime_1.jsx)("button", { className: "play-video-button text-primary bg-fill-primary border-primary group-hover:bg-fill-primary-hovered group-active:bg-fill-primary-pressed p-sm m-md md:m-3xl absolute bottom-0 left-0 flex items-center justify-center rounded-2xl border", children: (0, jsx_runtime_1.jsx)(MosaicIcon_1.MosaicIcon, { name: "play-arrow-outline" }) })] }));
};
exports.PreviewImage = PreviewImage;
const RenderPreviewImage = (videoUrl, el, playButtonAriaLabel, popupAriaLabel, closeButtonAriaLabel) => {
    (0, app_1.reactDOMRender)((0, jsx_runtime_1.jsx)(exports.PreviewImage, { videoUrl: videoUrl, playButtonAriaLabel: playButtonAriaLabel, popupAriaLabel: popupAriaLabel, closeButtonAriaLabel: closeButtonAriaLabel }), el);
};
exports.RenderPreviewImage = RenderPreviewImage;
